import api from "@/lib/api";

const VERSION_KEY = "gu_cache_v";

export const startCacheVersionWatch = () => {
  const check = async () => {
    try {
      const { data } = await api.get("/cache-version");
      const v = String(data.version || "");
      if (!v) return;
      const prev = localStorage.getItem(VERSION_KEY);
      if (prev && prev !== v) {
        localStorage.setItem(VERSION_KEY, v);
        try { localStorage.removeItem("gu_site_settings_v1"); } catch (e) { /* noop */ }
        window.location.reload();
        return;
      }
      localStorage.setItem(VERSION_KEY, v);
    } catch (e) { /* offline or backend restarting */ }
  };
  check();
  return setInterval(check, 60000);
};
